<form style="width: 25vw" [formGroup]="form">
  <div class="row">
    <div class="col-sm-12">
      <mat-form-field style="width: 100%">
        <mat-label i18n="@@ServiceHistory_Filters_EventTypesLabel"
          >Event Types</mat-label
          >
          <mat-select
            formControlName="eventFilter"
            >
            <mat-select-trigger>
              <mat-chip-set>
                <mat-chip>
                  {{ getLabelForEventType(data.eventFilter) }}
                </mat-chip>
              </mat-chip-set>
            </mat-select-trigger>
            @for (entryType of entryTypeFiltersAvailable; track entryType) {
              <mat-option
                [value]="entryType.value"
                >{{ entryType.label }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (showReceiptFilter) {
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field style="width: 100%">
              <mat-label i18n="@@ServiceHistory_Filters_ReceiptTypesLabel"
                >Receipt types</mat-label
                >
                <mat-select
                  multiple
                  formControlName="receiptTypeFilter"
                  >
                  <mat-select-trigger>
                    <mat-chip-set>
                      @for (val of data.receiptTypeFilter; track val) {
                        <mat-chip
                          [removable]="true"
                          (removed)="onReceiptTypeRemoved(val)"
                          >
                          {{ getLabelForReceiptType(val) }}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                      }
                    </mat-chip-set>
                  </mat-select-trigger>
                  @for (receiptType of receiptTypeFilterAvailable; track receiptType) {
                    <mat-option
                      [value]="receiptType.value"
                      >{{ receiptType.key }}</mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
          @if (showTasksFilter) {
            <div class="row">
              <div class="col">
                <frm-check
                  i18n-label="@@ServiceHistory_Filters_TasksShowDeleted"
                  label="Show deleted tasks"
                  formControlName="tasksShowDeleted"
                ></frm-check>
              </div>
            </div>
          }
          <div class="row">
            <div class="col-sm-12">
              <div mat-dialog-actions>
                <ctrl-btn-accept style="padding-right: 10px;"
          [disabled]="
            this.data.eventFilter === null ||
            this.data.eventFilter === undefined
          "
                  [mat-dialog-close]="this.data"
                ></ctrl-btn-accept>
                <ctrl-btn-cancel style="padding-right: 10px;" (click)="onNoClick()"></ctrl-btn-cancel>
              </div>
            </div>
          </div>
        </form>
